import type { StyleSpecification } from 'maplibre-gl';

/** A quiet, flat operations map: warm buildings, white roads and pale parks. */
export function styleOrderBasemap(style: StyleSpecification): StyleSpecification {
  return {
    ...style,
    layers: style.layers.map((layer) => {
      const id = layer.id;
      if (layer.type === 'background')
        return { ...layer, paint: { 'background-color': '#fafbf7' } };
      if (
        layer.type === 'fill-extrusion' ||
        id === 'natural_earth' ||
        id.includes('shield') ||
        id.includes('one_way')
      )
        return { ...layer, layout: { ...layer.layout, visibility: 'none' } };
      if (layer.type === 'fill') {
        const color = id.includes('water')
          ? '#dcecf0'
          : /park|wood|grass|cemetery|pitch/.test(id)
            ? '#e9f2e3'
            : id.includes('building')
              ? '#f0efe7'
              : '#f7f8f2';
        return {
          ...layer,
          paint: {
            ...layer.paint,
            'fill-color': color,
            'fill-opacity': 1,
            'fill-outline-color': id.includes('building') ? '#e3e2d9' : color,
          },
        };
      }
      if (layer.type === 'line')
        return {
          ...layer,
          paint: {
            ...layer.paint,
            'line-color': id.includes('water')
              ? '#dcecf0'
              : /rail|casing/.test(id)
                ? '#dedfd9'
                : '#ffffff',
          },
        };
      if (layer.type === 'symbol')
        return {
          ...layer,
          minzoom: id.startsWith('poi_')
            ? Math.max(layer.minzoom ?? 0, 16)
            : (layer.minzoom ?? 0),
          paint: {
            ...layer.paint,
            'text-color': '#7e837d',
            'text-halo-color': '#fafbf7',
            'text-halo-width': 1,
          },
        };
      return layer;
    }),
  };
}
